export const DEFAULT_MAX_COLLAPSED_LINE = 5;
export const DEFAULT_BUTTON_COLLAPSE_TEXT = "Show less";
export const DEFAULT_BUTTON_EXPAND_TEXT = "Show more";

/** Collapsed RDA body height — ~9 visible lines (matches design reference). */
export const RDA_COLLAPSED_MAX_HEIGHT_PX = 180;
